<template>
  <div>
    <label
      :for="control.name + '_gui_control'"
      class="form-control-label"
      :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
    >{{control.label}}</label>
    <div>
      <div v-if="loaded">
        <DataGrid
          v-if="dataGrid_options[gridId].meta[control.propName]"
          :gridId="`${[dataGrid_options[gridId].meta[control.propName].dataGrid]}`"
          :widgetKey="this.makeid(20)"
          :defaultFilter="{ [dataGrid_options[gridId].meta[control.propName].filterColumn]: rowKey }"
          :fbField="this.dataGrid_options[this.gridId].meta[this.control.propName].filterColumn"
          ref="dataGrid"
          :hideToolbar="control.hideToolbar"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

export default {
  props: ['control', 'labelPosition'],
  data() {
    return {
      gridId: null,
      rowKey: null,
      watchGridId: null,
      loaded: false,
    }
  },
  computed: {
    ...mapState(['dataGrid_options']),
  },
  methods: {
    makeid(length) {
      var result = ''
      var characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var charactersLength = characters.length
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        )
      }
      return result
    },
    updateCell(rowKey, updatedCallback) {
      const data = {
        options: this.dataGrid_options[this.watchGridId],
        rowKey,
        cellKey: this.dataGrid_options[this.gridId].meta[this.control.propName]
          .filterColumn,
        value: this.rowKey,
      }

      db.dataGrid.data.saveCellVal(data).then(() => {
        if (updatedCallback) updatedCallback()
      })
    },
  },
  mounted() {
    let formBuilderInst = this

    while (!$(formBuilderInst.$el).hasClass('form-builder-root')) {
      formBuilderInst = formBuilderInst.$parent
    }

    this.gridId = formBuilderInst.gridId
    this.rowKey = formBuilderInst.rowKey
    this.loaded = true

    const meta = this.dataGrid_options[this.gridId].meta

    if (!meta) return

    this.watchGridId = meta[this.control.propName].dataGrid

    eventBus.$on(`fbRowAdded-${this.watchGridId}`, this.updateCell)
  },
  beforeDestroy() {
    eventBus.$off(`fbRowAdded-${this.watchGridId}`, this.updateCell)
  },
}
</script>
